var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"min-height":"250px"}},[_c('b-spinner',{class:_vm.textColor}),(_vm.text)?_c('div',{staticClass:"m-2",class:_vm.textColor},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }